import { setSpecificMessage, maxValue } from "valibot";
setSpecificMessage(
  maxValue,
  (issue) => `Valeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);